import React from 'react';
import { LINK_STATUS } from '../../constants/abdmCopy';

/**
 * CareContextStatusChip — M2, care-context link status chip (used in HIP rows and LinkedRecordsList).
 *
 * LINK_PENDING is intentionally excluded from any retry condition wherever this chip's
 * status is consumed — it represents an in-flight/awaiting-link state, not a terminal
 * notification failure.
 */
const STATUS_META = {
  LINKED:       { label: 'Linked',       bg: '#dcfce7', dark: '#14532d', text: '#166534', darkText: '#bbf7d0' },
  NOTIFIED:     { label: LINK_STATUS.NOTIFIED, bg: '#fef9c3', dark: '#713f12', text: '#854d0e', darkText: '#fef08a' },
  CREATED:      { label: LINK_STATUS.CREATED, bg: '#e0f2fe', dark: '#0c4a6e', text: '#0369a1', darkText: '#bae6fd' },
  LINK_PENDING: { label: 'Linking…',     bg: '#fef9c3', dark: '#713f12', text: '#854d0e', darkText: '#fef08a' },
  FAILED:       { label: LINK_STATUS.FAILED, bg: '#fee2e2', dark: '#7f1d1d', text: '#991b1b', darkText: '#fca5a5' },
  ARCHIVED:     { label: 'Archived',     bg: '#f3f4f6', dark: '#1f2937', text: '#4b5563', darkText: '#9ca3af' },
};

export const CARE_CONTEXT_RETRYABLE_STATUSES = new Set(['CREATED']);

export default function CareContextStatusChip({ status, isDark }) {
  const meta = STATUS_META[status] ?? STATUS_META.CREATED;
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 99,
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: '0.03em',
      background: isDark ? meta.dark : meta.bg,
      color: isDark ? meta.darkText : meta.text,
    }}>
      {meta.label}
    </span>
  );
}
